import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { AbstractModel } from '@uzurv/core';
import { TransitProgram } from './transit-program';
import { ComplianceStatus } from './compliance-status';

@inheritSerialization(AbstractModel)
export class TransitProgramProvider extends AbstractModel {
  @autoserializeAs(TransitProgram)
  transitProgram: TransitProgram;

  @autoserialize
  status: string;

  @autoserialize
  complianceStatus: ComplianceStatus;
}
